import React, { useEffect } from "react";
import AppInfo from "../../Pages/Report/AppInfo";
import AboutProject from "../../Pages/Report/AboutProject";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ProjectModificationRequestsTable from "../../Pages/Report/ProjectModificationRequests";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import { GetSpecificRowReport } from "../../Redux/Reducers/ReportStage/Report";

function EmployeeTransfers(props) {
  const dispatch=useDispatch()
  const ReportRow = useSelector((state) => state.ReportStatus.ReportRow);
  const { reportId } = useParams();
  
  console.log(reportId,"ssssssssdwdwdwd");
  
useEffect(()=>{
dispatch(GetSpecificRowReport({
  reportId: reportId
}))
},[reportId])
  return (
    <>
      <AppInfo reportId={reportId} />
      <AboutProject
        disabled={true}
        ReportRow={ReportRow}
        setOverallProjectObjective={ReportRow?.overallProjectObjective}
        setExpectedProjectDeliverables={ReportRow?.expectedProjectDeliverables}
        setAgreementAttachment={ReportRow?.agreementAttachment}
        reportId={reportId}
      />
      <SharedDiv
        showTitle={true}
        titleName="طلبات التعديل على المشروع"
        child={[
          <>
            <ProjectModificationRequestsTable  reportId={reportId}  />
          </>,
        ]}
      />
    </>
  );
}

export default EmployeeTransfers;
